export const PRODUCT_SELECT = 'Product select. Step: Product Interest'
